<template>
  <div class="login">
    <div class="nav-box" />

    <div class="echarts-box">
      <div class="left-col">
        <div class="title-box">
          <span
            v-for="(item, index) in leftTitleList"
            :key="index"
            :class="Import === index ? 'text on' : 'text'"
            @click="handleClickImport(item.value)"
          >{{ item.label }}</span>
        </div>

        <div
          v-show="Import === 0"
          class="left-echart-container"
        >
          <p class="summaryData">金额16885（万元）、总单量1371525（票）</p>

          <div class="echarts-con">
            <div
              id="bondedImportBar01"
              class="echarts-container01"
            />
            <div
              id="bondedImportLine01"
              class="echarts-container01"
              style="margin-top: 20px;"
            />
          </div>
        </div>

        <div
          v-show="Import === 1"
          class="left-echart-container"
        >
          <p class="summaryData">金额18985（万元）、总单量1500689（票）</p>

          <div class="echarts-con">
            <div
              id="bondedImportBar02"
              class="echarts-container01"
            />
            <div
              id="bondedImportLine02"
              class="echarts-container01"
              style="margin-top: 20px;"
            />
          </div>
        </div>

        <div class="title-box">
          <!-- <span class="text">合作企业</span> -->
          <span class="text">监管类型和国别地区</span>
        </div>

        <div class="echarts-con">
          <ul class="part-box">
            <!-- <div class="part-item" v-for="(item, index) in partList" :key="index">
              <div class="item-img">
                <img class="img-center" :src="item.src" :alt="item.title" />
              </div>
              <div class="item-title">{{ item.title }}</div>
            </div> -->

            <div class="left-guobie">
              <p class="title">监管类型：</p>
              <div
                id="jianguanPie"
                class="jianguan-box"
              />
            </div>

            <div class="right-guobie">
              <p class="title">国别地区：</p>
              <div
                id="guobieBar"
                class="guobie-box"
              />
            </div>
          </ul>
        </div>
      </div>

      <div class="center-col">
        <ul class="total-box">
          <li
            v-for="(item, index) in totalList"
            :key="index"
            class="item-box"
          >
            <div class="item-left">
              <img
                :src="item.src"
                alt=""
              >
            </div>
            <div class="item-right">
              <animate-number
                :key="index"
                class="item-num"
                from="0"
                :to="item.num"
                duration="2000"
              />
              <div class="item-title">{{ item.title }}</div>
            </div>
          </li>
        </ul>

        <ningde-svg :svg-class="svgClass" />

        <ul class="cover-box">
          <li
            v-for="(item, index) in coverArr"
            :key="index"
            class="item-box"
          >
            <div class="item-left">
              <img
                :src="item.src"
                alt=""
              >
            </div>
            <div class="item-right">
              <animate-number
                :key="index"
                class="item-num"
                from="0"
                :to="item.num"
                duration="2000"
              />
              <div class="item-title">{{ item.title }}</div>
            </div>
          </li>
        </ul>
      </div>

      <div class="right-col">
        <div class="title-box">
          <span
            v-for="(item, index) in rightTitleList"
            :key="index"
            :class="Export === index ? 'text on' : 'text'"
            @click="handleClickExport(item.value)"
          >{{ item.label }}</span>
        </div>

        <div
          v-show="Export === 0"
          class="right-echart-container"
        >
          <p class="summaryData">金额40639（万元）、总单量831327（票）</p>

          <div class="echarts-con">
            <div
              id="bondedExportBar01"
              class="echarts-container02"
            />
            <div
              id="bondedExportLine01"
              class="echarts-container02"
              style="margin-top: 10px;"
            />
          </div>
        </div>

        <div
          v-show="Export === 1"
          class="right-echart-container"
        >
          <p class="summaryData">金额51664（万元）、总单量961566（票）</p>

          <div class="echarts-con">
            <div
              id="bondedExportBar02"
              class="echarts-container02"
            />
            <div
              id="bondedExportLine02"
              class="echarts-container02"
              style="margin-top: 10px;"
            />
          </div>
        </div>

        <div class="title-box">
          <span class="text">时间轴</span>
        </div>

        <div
          class="echarts-con"
          style="padding: 0;"
        >
          <div class="timeline-box">
            <img
              class="img-center"
              src="@/assets/images/timeline.png"
              alt="时间轴"
            >
          </div>
        </div>

        <div class="title-box">
          <span class="text">上线成效</span>
        </div>

        <div
          class="echarts-con"
          style="padding: 16px 0 0;"
        >
          <ul class="onlineEffect-box">
            <li
              v-for="(item, index) in onLineList"
              :key="index"
              class="online-item"
            >
              <p class="title">{{ item.title }}</p>
              <p class="title">
                <animate-number
                  class="num"
                  :from="item.from"
                  :to="item.to"
                  :duration="item.duration"
                />
                {{ item.unit }}
              </p>
              <div class="online-img">
                <img
                  class="img-center"
                  :src="item.src"
                  alt="成效"
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
// import api from '../util/api';
import NingdeSvg from '@/components/ningdeSvg'

export default {
  name: 'Login',
  components: { NingdeSvg },
  data() {
    const that = this

    return {
      leftTitleList: [
        { label: '保税进口', value: 0 },
        { label: '直购进口', value: 1 }
      ],
      Import: 0,
      leftFirst: false,
      rightTitleList: [
        { label: '保税出口', value: 0 },
        { label: '直购出口', value: 1 }
      ],
      Export: 0,
      rightFirst: false,
      BarImportData: [
        [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
        [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 235.2, 48.7, 18.8, 6.0, 2.3]
      ],
      BarExportData: [
        [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
        [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 240.2, 48.7, 18.8, 6.0, 2.3]
      ],
      barOption: {
        legend: {
          data: ['金额', '单量'],
          selectedMode: true,
          textStyle: {
            color: '#fff',
            fontSize: 10
          },
          top: '10',
          right: '5%',
          itemWidth: 20,
          itemHeight: 10
        },
        grid: {
          top: 40,
          bottom: 20
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          name: '（月）',
          nameTextStyle: {
            // align: "right",
            lineHeight: 48,
            color: '#fff',
            fontSize: 10
          },
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线
            lineStyle: {
              color: '#0f2652' // 坐标轴线线的颜色
            }
          }
        },
        yAxis: {
          name: '单位：金额（万元）、单量（票）',
          nameTextStyle: {
            align: 'left',
            color: '#fff',
            fontSize: 10
          },
          type: 'value',
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            show: true, // 是否显示坐标轴轴线
            lineStyle: {
              color: '#0f2652', // 坐标轴线线的颜色
              width: '1', // 坐标轴线线宽
              type: 'solid' // 坐标轴线线的类型（solid实线类型；dashed虚线类型；dotted点状类型）
            }
          }
        },
        series: [
          {
            name: '金额',
            type: 'bar',
            barWidth: '20%',
            data: [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ddedde' },
                { offset: 0.6, color: '#cda35a' },
                { offset: 1, color: '#0d3559' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#ddedde' },
                  { offset: 0.6, color: '#cda35a' },
                  { offset: 1, color: '#0d3559' }
                ])
              }
            }
            /* markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            } */
          },
          {
            name: '单量',
            type: 'bar',
            barWidth: '20%',
            data: [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#4984cf' },
                { offset: 0.6, color: '#3367af' },
                { offset: 1, color: '#0b2859' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#4984cf' },
                  { offset: 0.6, color: '#3367af' },
                  { offset: 1, color: '#0b2859' }
                ])
              }
            }
            /* markPoint: {
              data: [
                { name: 'Max', value: 182.2, xAxis: 7, yAxis: 183 },
                { name: 'Min', value: 2.3, xAxis: 11, yAxis: 3 }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            } */
          }
        ]
      },

      LineImportData: [
        [42, 54, 50, 86, 108, 90, 110, 122, 115, 150, 124, 120],
        [75, 110, 84, 54, 75, 120, 116, 146, 140, 174, 166, 240]
      ],
      LineExportData: [
        [42, 54, 50, 86, 108, 90, 110, 122, 115, 150, 124, 120],
        [75, 110, 84, 54, 75, 120, 116, 146, 140, 174, 166, 240]
      ],
      lineOption: {
        legend: {
          data: ['金额', '单量'],
          selectedMode: true,
          textStyle: {
            color: '#fff',
            fontSize: 10
          },
          top: '10',
          right: '5%',
          icon: 'roundRect',
          itemWidth: 20,
          itemHeight: 10
        },
        grid: {
          top: 40,
          bottom: 20
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          name: '（月）',
          nameTextStyle: {
            // align: "right",
            lineHeight: 48,
            color: '#fff',
            fontSize: 10
          },
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线
            lineStyle: {
              color: '#0f2652' // 坐标轴线线的颜色
            }
          }
        },
        yAxis: {
          name: '单位：金额（万元）、单量（票）',
          nameTextStyle: {
            align: 'left',
            color: '#fff',
            fontSize: 10
          },
          type: 'value',
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            show: true, // 是否显示坐标轴轴线
            lineStyle: {
              color: '#0f2652', // 坐标轴线线的颜色
              width: '1', // 坐标轴线线宽
              type: 'solid' // 坐标轴线线的类型（solid实线类型；dashed虚线类型；dotted点状类型）
            }
          }
        },
        series: [
          {
            name: '金额',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            data: [],
            itemStyle: {
              color: '#ffbc33'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 211, 113, 1)' },
                { offset: 1, color: 'rgba(255, 211, 113, 0.15)' }
              ])
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255, 211, 113, 1)' },
                  { offset: 1, color: 'rgba(255, 211, 113, 0.15)' }
                ])
              }
            }
          },
          {
            name: '单量',
            type: 'line',
            // stack: 'Total',
            // label: {
            //   show: true,
            //   position: 'top'
            // },
            smooth: true,
            data: [],
            itemStyle: {
              color: '#2ed7f6'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(46, 215, 246, 1)' },
                { offset: 1, color: 'rgba(46, 215, 246, 0.15)' }
              ])
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(46, 215, 246, 1)' },
                  { offset: 1, color: 'rgba(46, 215, 246, 0.15)' }
                ])
              }
            }
          }
        ]
      },

      coverArr: [
        {
          title: '覆盖电商产业园（个）',
          num: 9,
          src: require('@/assets/images/covericon01.png')
        },
        {
          title: '覆盖电商中心（个）',
          num: 3,
          src: require('@/assets/images/covericon02.png')
        },
        {
          title: '覆盖电商直播基地（个）',
          num: 20,
          src: require('@/assets/images/covericon03.png')
        }
      ],

      svgClass: 'svg-container',

      totalList: [
        {
          title: '进口总金额（万元）',
          num: 7399,
          src: require('@/assets/images/totalicon01.png')
        },
        {
          title: '进口总单量（票）',
          num: 452644,
          src: require('@/assets/images/totalicon02.png')
        },
        {
          title: '出口总金额（万元）',
          num: 1288,
          src: require('@/assets/images/totalicon03.png')
        },
        {
          title: '出口总单量（票）',
          num: 1615650,
          src: require('@/assets/images/totalicon04.png')
        }
      ],

      partList: [
        {
          title: '京东',
          src: require('@/assets/images/partLogo01.png')
        },
        {
          title: '抖音',
          src: require('@/assets/images/partLogo02.png')
        },
        {
          title: '宁波国际物流',
          src: require('@/assets/images/partLogo03.png')
        },
        {
          title: '阿里巴巴国际站',
          src: require('@/assets/images/partLogo04.png')
        },
        {
          title: '亚马逊',
          src: require('@/assets/images/partLogo05.png')
        },
        {
          title: '重庆大龙网',
          src: require('@/assets/images/partLogo06.png')
        }
      ],

      guobieData: [
        [120, 106, 140, 98, 136],
        [108, 160, 124, 120, 188]
      ],
      guobieOption: {
        legend: {
          data: ['出口', '进口'],
          selectedMode: true,
          textStyle: {
            color: '#fff',
            fontSize: 10
          },
          top: '10',
          right: '0',
          itemWidth: 20,
          itemHeight: 10
        },
        grid: {
          top: 40,
          bottom: 20,
          right: '0',
          left: '30'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          name: '国别地区',
          nameTextStyle: {
            // align: "right",
            lineHeight: 48,
            color: '#fff',
            fontSize: 0
          },
          type: 'category',
          data: ['俄罗斯', '德国', '英国', '法国', '港澳台'],
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线
            lineStyle: {
              color: '#0f2652' // 坐标轴线线的颜色
            }
          }
        },
        yAxis: {
          name: '单位：金额（万元）',
          nameTextStyle: {
            align: 'left',
            color: '#fff',
            fontSize: 0
          },
          type: 'value',
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            show: true, // 是否显示坐标轴轴线
            lineStyle: {
              color: '#0f2652', // 坐标轴线线的颜色
              width: '1', // 坐标轴线线宽
              type: 'solid' // 坐标轴线线的类型（solid实线类型；dashed虚线类型；dotted点状类型）
            }
          }
        },
        series: [
          {
            name: '出口',
            type: 'bar',
            barWidth: '12%',
            data: [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ddedde' },
                { offset: 0.6, color: '#cda35a' },
                { offset: 1, color: '#0d3559' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#ddedde' },
                  { offset: 0.6, color: '#cda35a' },
                  { offset: 1, color: '#0d3559' }
                ])
              }
            }
            /* markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            } */
          },
          {
            name: '进口',
            type: 'bar',
            barWidth: '12%',
            data: [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#4984cf' },
                { offset: 0.6, color: '#3367af' },
                { offset: 1, color: '#0b2859' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#4984cf' },
                  { offset: 0.6, color: '#3367af' },
                  { offset: 1, color: '#0b2859' }
                ])
              }
            }
            /* markPoint: {
              data: [
                { name: 'Max', value: 182.2, xAxis: 7, yAxis: 183 },
                { name: 'Min', value: 2.3, xAxis: 11, yAxis: 3 }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            } */
          }
        ]
      },

      jianguanData: [
        { value: 240, name: '9710' },
        { value: 450, name: '9610' },
        { value: 150, name: '1210' },
        { value: 160, name: '9810' }
      ],
      jianguanOption: {
        color: ['#23cae9', '#206cee', '#e6b950', '#21cb78'],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '2%',
          left: 'center',
          // 字体大小
          textStyle: {
            // lineHeight: 16,
            padding: [0, 0, 0, 0],
            color: '#fff',
            fontSize: 10
          },
          // 左侧小图标
          itemWidth: 12,
          itemHeight: 12,
          // 一行只显示两个
          formatter: function(name) {
            var index = 0
            var all = that.jianguanData.reduce((prev, curr) => {
              // eslint-disable-next-line no-return-assign
              return prev += curr.value
            }, 0)
            for (var i = 0; i < that.jianguanData.length; i++) {
              if (that.jianguanData[i].name == name) {
                index = i
                break
              }
            }
            return name + ':  ' + that.jianguanData[index].value / all * 100 + '%'
          }
        },
        series: [
          {
            name: '监管类型',
            type: 'pie',
            radius: ['40%', '60%'],
            // 饼图整体上移
            center: ['50%', '36%'],
            avoidLabelOverlap: false,
            padAngle: 2, // 饼图扇区之间的间隔
            itemStyle: {
              borderRadius: 0
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      },

      onLineList: [
        {
          title: '覆盖电商企业',
          unit: '余家',
          from: 0,
          to: '10000',
          duration: '2000',
          src: require('@/assets/images/online.png')
        },
        {
          title: '覆盖网店',
          unit: '余家',
          from: 0,
          to: '50000',
          duration: '2000',
          src: require('@/assets/images/online.png')
        },
        {
          title: '覆盖商品',
          unit: '余件',
          from: 0,
          to: '56000',
          duration: '2000',
          src: require('@/assets/images/online.png')
        }
      ]
    }
  },
  watch: {
    $route: {
      // handler: function(route) {
      //   this.redirect = route.query && route.query.redirect;
      // },
      // immediate: true
    }
  },
  mounted() {
    this.BarEchartsInit('bondedImportBar01', this.BarImportData)
    this.LineEchartsInit('bondedImportLine01', this.LineImportData)

    this.BarEchartsInit('bondedExportBar01', this.BarExportData)
    this.LineEchartsInit('bondedExportLine01', this.LineExportData)

    this.guobieEchartsInit('guobieBar', this.guobieData)
    this.jianguanEchartsInit('jianguanPie', this.jianguanData)
  },
  methods: {
    BarEchartsInit(el, seriesData) {
      for (let i = 0; i < seriesData.length; i++) {
        this.$set(this.barOption.series[i], 'data', seriesData[i])
      }

      var myChartBar = echarts.init(document.getElementById(el))
      myChartBar.setOption(this.barOption)
    },
    LineEchartsInit(el, seriesData, areaStyleBoolean) {
      for (let i = 0; i < seriesData.length; i++) {
        this.$set(this.lineOption.series[i], 'data', seriesData[i])
        if (!areaStyleBoolean) {
          this.$set(this.lineOption.series[i], 'areaStyle', {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(255, 211, 113, 0)' },
              { offset: 1, color: 'rgba(255, 211, 113, 0)' }
            ])
          })
        }
      }

      var myChartLine = echarts.init(document.getElementById(el))
      myChartLine.setOption(this.lineOption)
    },
    guobieEchartsInit(el, seriesData) {
      for (let i = 0; i < seriesData.length; i++) {
        this.$set(this.guobieOption.series[i], 'data', seriesData[i])
      }

      var guobieChartBar = echarts.init(document.getElementById(el))
      guobieChartBar.setOption(this.guobieOption)
    },
    jianguanEchartsInit(el, seriesData) {
      this.$set(this.jianguanOption.series[0], 'data', seriesData)

      var jianguanChartBar = echarts.init(document.getElementById(el))
      jianguanChartBar.setOption(this.jianguanOption)
    },
    handleClickImport(value) {
      this['Import'] = value

      if (value === 1 && !this.leftFirst) {
        this.BarEchartsInit('bondedImportBar02', this.BarImportData)
        this.LineEchartsInit('bondedImportLine02', this.LineImportData)
        this.leftFirst = true
      }
    },
    handleClickExport(value) {
      this['Export'] = value

      if (value === 1 && !this.rightFirst) {
        this.BarEchartsInit('bondedExportBar02', this.BarImportData)
        this.LineEchartsInit('bondedExportLine02', this.LineImportData)
        this.rightFirst = true
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less" scoped>
/deep/ html, body {
  height: 100% !important;
  margin: 0;
  padding: 0;
  line-height: 1 !important;
}

/deep/.app {
  height: 100% !important;
  overflow: auto;
}

.login {
  height: 100%;
  min-height: 1080px;
  background-image: url("../../assets/images/login-background.jpg");
  background-size: 100% 100%;
}

.nav-box {
  height: 152px;
  margin-bottom: -30px;
  background-image: url("../../assets/images/nav_bg.png");
  background-size: 100% 100%;
}

.title-box {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 41px;
  padding: 0 30px 0 50px;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  background-image: url("../../assets/images/title_bg.png");
  background-size: 100% 100%;

  .text {
    display: inline-block;
    vertical-align: middle;
    height: 30px;
    margin-top: -6px;

    &.on {
      color: #3876e8;
      background: url("../../assets/images/title_on.png") center bottom no-repeat;
      background-size: contain;
    }
  }
}

.summaryData {
  padding: 10px 20px 0;
  font-size: 14px;
  font-weight: bold;
  color: #3876e8;
}

.echarts-box {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 100%;

  .left-col {
    width: 28%;
  }

  .center-col {
    width: 38%;
  }

  .right-col {
    width: 28%;
  }
}

.echarts-con {
  padding-right: 10px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  background-image: url("../../assets/images/echarts_con_bg.png");
  background-size: 100% 100%;
}

.echarts-container01 {
  width: 522px;
  height: 260px;
}

.echarts-container02 {
  width: 522px;
  height: 220px;
}

.part-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 16px 14px 0;

  .part-item {
    width: 156px;
    margin: 0 0 10px;
    text-align: center;
    color: #fff;
  }

  .item-img {
    height: 72px;
    background-image: url("../../assets/images/item_img_bg.png");
    background-size: 100% 100%;
  }

  .item-title {
    font-size: 14px;
  }
}

.left-guobie {
  width: 210px;

  .title {
    font-size: 14px;
    color: #fff;
  }
}

.right-guobie {
  width: 280px;

  .title {
    margin-bottom: -20px;
    font-size: 14px;
    color: #fff;
  }
}

.jianguan-box {
  height: 210px;
}

.guobie-box {
  height: 230px;
}

.timeline-box {
  height: 150px;
}

.onlineEffect-box {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  font-size: 14px;
  color: #fff;

  .online-item {
    width: 118px;
  }

  .online-img {
    height: 70px;
  }

  .num {
    font-size: 22px;
    font-weight: bold;
    color: #3876e8;
    background-image: -webkit-linear-gradient(135deg, #40ddff 0%, #affbfc 100%);
    background-image: -ms-linear-gradient(135deg, #40ddff 0%, #affbfc 100%);
    background-image: -moz-linear-gradient(135deg, #40ddff 0%, #affbfc 100%);
    background-image: -o-linear-gradient(135deg, #40ddff 0%, #affbfc 100%);
    background-image: linear-gradient(180deg, #40ddff, #affbfc);
    -webkit-text-fill-color: #fff;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.center-col {
  .item-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .item-num {
    font-size: 22px;
    font-weight: bold;
    background: linear-gradient(to bottom, #fefefe, #90b2f4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .item-title {
    font-size: 10px;
  }
}

.total-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;

  .item-box {
    padding: 8px 10px;
    background-image: url("../../assets/images/item_img_bg.png");
    background-size: 100% 100%;
  }
}

.cover-box {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #fff;

  .item-box {
    padding: 9px 36px;
    background: url("../../assets/images/cover_item_bg.png") bottom center no-repeat;
    background-size: contain;
  }
}

.one {
  background: linear-gradient(to right, #f5dbb2, #f0a869, #f5dbb2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.two {
  background: linear-gradient(to right, #e8e8e8, #9d9687, #e8e8e8);
  /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
  -webkit-background-clip: text;
  /*将设置的背景颜色限制在文字中*/
  -webkit-text-fill-color: transparent;
  /*给文字设置成透明*/
}

.three {
  background: linear-gradient(to right, #d4b9b2, #d2937d, #d4b9b2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/*reset*/
* {
  box-sizing: border-box;
}

body {
  position: relative;
  margin: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", "simsun", "Helvetica Neue", Arial, Helvetica, sans-serif;
  background-color: #fffbf7;
}

div {
  position: relative;
}

img {
  display: inline-block;
  vertical-align: bottom;
  max-width: 100%;
  height: auto;
  border: none;
}

a {
  color: inherit;
  text-decoration: inherit;
  cursor: pointer;
}

a:link {
  color: inherit;
  text-decoration: inherit;
}

/* 未访问的链接 */
a:visited {
  color: inherit;
  text-decoration: inherit;
}

/* 已访问的链接 */
a:hover {
  color: inherit;
  text-decoration: inherit;
}

/* 鼠标移动到链接上 */
a:active {
  color: inherit;
  text-decoration: inherit;
}

/* 选定的链接 */
h1 {
  font-size: 32px;
}

h2 {
  font-size: 24px;
}

h3 {
  font-size: 18px;
}

h4 {
  font-size: 16px;
}

h5 {
  font-size: 14px;
}

h6 {
  font-size: 12px;
}

p,
h1,
h2,
h3,
h4,
h5,
h6,
dl,
dt,
dd,
blockquote {
  margin: 0;
  position: relative;
}

ul,
ol,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

canvas {
  width: 300px;
  height: 150px;
}

input:focus {
  outline: none;
}

.container {
  position: relative;
  width: 1400px;
  margin: 0 auto;
  padding: 64px 124px;
}

.row:after,
.line:after {
  display: block;
  content: "";
  clear: both;
  line-height: 0;
  visibility: hidden;
}

.clear {
  clear: both;
  line-height: 0;
}

.img-box {
  position: relative;
}

.img-center {
  max-width: 100%;
  max-height: 100%;
  _width: 100%;
  _height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.img-inline {
  display: inline-block;
  width: 100%;
  height: auto;
}

.img-cover {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  *width: 100%;
  *height: 100%;
  border: none;
  object-position: 50% 50%;
  object-fit: cover;
}

.cover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 7;
}

.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.inline-block {
}

.text_center {
  text-align: center;
}

.text_right {
  text-align: right;
}

/*top*/
.top {
  background: #f2f2f2;
  color: #a6a6a6;
  font-size: 12px;
  height: 34px;
  line-height: 34px;
  border-bottom: 1px solid #e5e5e5;
}

.top span {
  margin: 0 9px;
  line-height: 34px;
}

.top .welcome {
  margin: 0;
  float: left;
}

.top .user_ctrl {
  margin: 0;
  float: right;
}

.top .user_ctrl a {
  padding: 0 10px;
}

.top .user_ctrl a.user2 {
  background: #006DE6;
  color: #fff;
}

.top .user_ctrl .icon {
  vertical-align: middle;
  padding: 0 5px;
}

/*header*/
.logo img {
  display: block;
  max-height: 88px;
}

.header {

}

/*footer*/
.footer {
  background: #eaeaea;
  height: 228px;
  margin: 15px 0 0 0;
}

.footer_service {
  padding: 15px 0 14px;
  border-bottom: 1px solid #c7c7c7;
  background: #f5f5f5;
  font-size: 22px;
}

.footer_service li {
  float: left;
  width: 25%;
}

.footer_service img {
  vertical-align: middle;
  margin: 0 15px 0 30px;
}

.copyright {
  text-align: center;
}

.footer_logo,
.footer_link,
.footer_QR {
  display: inline-block;
  margin: 30px 15px;
  vertical-align: top;
}

.footer_logo {
  width: 60px;
  position: relative;
  top: 25px;
}

.footer_link {
  text-align: left;
  font-size: 12px;
  color: #4b4b4b
}

.footer_link h6 {
  padding: 10px 0;
  border-bottom: 1px dashed #4b4b4b;
}

.footer_link h6 a {
  margin: 0 1em;
}

.footer_link p {
  line-height: 20px;
}

.footer_QR dd {
  padding: 7px;
  border: 1px solid #c8c8c8;
}

.footer_QR dt {
  padding: 9px 10px;
  background: #c8c8c8;
  font-weight: 900;
  font-size: 12px;
}

.page {
}

/*面包屑导航*/
.bread {
  font-size: 14px;
  margin: 0 0 10px;
}

.bread li {
  display: inline-block;
  *display: inline;
  zoom: 1;
}

.bread li a:before {
  content: '>';
  margin: 0.25em;
}

.bread li.bread_index a:before {
  content: ' ';
  margin: 0;
}

.bread li.on {
  color: #0072e3;
}

/*内页左右布局*/
.section {
}

.aside {
}

.section.fl {
  width: 73.6666%;
  margin: 0 0 15px 0;
}

.aside.fr {
  width: 23.8333%;
  margin: 0 0 15px 0;
}

.aside.fl {
  width: 20%;
  margin: 0 0 15px 0;
}

.section.fr {
  width: 76.9166%;
  margin: 0 0 15px 0;
}

.section.fl .panel {
  margin: 0 0 30px;
}

.section.fr .panel {
  margin: 0 0 10px;
}

.section .panel_head {
  font-size: 18px;
  margin: 0px 0 0;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #c9c9c9;
  color: #044c96;
  vertical-align: middle;
}

.section.fr .panel_head {
  padding: 0 0 20px
}

.section .panel_head img {
  vertical-align: bottom;
  margin: 0 0 -4px;
}

.section .panel_head .more {
  padding: 1.5em 0 0 0;
  font-size: 12px;
}

/*分页模块*/
.pagination {
  margin: 30px;
}

.pagination li {
  display: inline-block;
  margin: 4px;
  padding: 2px 0.5em;
  background: #ebf5fe;
  color: #006de6;
}

.pagination li.on {
  background: #006de3;
  color: #fff;
}

.pagination .jump {
  display: inline-block;
}

.pagination .jump .input_submit {
  padding: 2px 1em;
  border: none;
  background: #006DE3;
  color: #fff;
  cursor: pointer;
}

/*分色列表*/
.color_list li {
  line-height: 35px;
}

.color_list .odd {
  background-color: #fff;
}

.color_list .even {
  background-color: #f1f8ff;
}

.flip {
  font-size: 12px;
  width: 45%;
  margin: 20px 0;
}

.flip .ellipsis {
  display: inline-block;
  width: 80%;
  color: #333;
  vertical-align: bottom;
}

</style>
